import React, { Component } from 'react';
import { message } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { putCompanyTest } from '../../actions/asyncActions';
import TestSettingsForm from '../forms/TestSettingsForm';
import Modal from './Modal';

class TestSettingsModal extends Component {
    render() {
        const { modal, params, putCompanyTest } = this.props;

        return <Modal
            {...modal}
            title='Редактировать настройки теста'
            footer={null}>
            <TestSettingsForm
                item={params}
                formAction={putCompanyTest} />
        </Modal>;
    }
}

export default withAsyncActions({
    putCompanyTest: putCompanyTest
        .withSuccessHandler(({ close }) => {
            message.success('Настройки успешно сохранены');
            close();
        })
        .withErrorHandler(() => message.error('Не удалось сохранить настройки'))
        .withOptions({ resetOnUnmount: true })
})(TestSettingsModal);
